
import 'components/datatable.tag'
import 'pages/images/images-gallery-modal.tag'
riot.tag2('product-edit-images', '  <div class="row">\n    <div class="col-md-12">\n      <catalog-static name="{opts.name}" cols="{cols}" rows="{value}" handlers="{handlers}" catalog="{catalog}" upload="{upload}" remove="true" reorder="true">\n        <yield to="toolbar">\n          <div class="form-group" if="{checkPermission(&quot;images&quot;, &quot;0100&quot;)}">\n            <div class="input-group btn btn-primary btn-file">\n              <input name="files" onchange="{opts.upload}" type="file" multiple="multiple" accept="image/*"><i class="fa fa-plus"></i> Добавить\n            </div>\n          </div>\n          <div class="form-group" if="{checkPermission(&quot;images&quot;, &quot;1000&quot;) &amp;&amp; !parent.opts.hidecatalog}">\n            <button class="btn btn-success" onclick="{opts.catalog}" type="button"><i class="fa fa-picture-o"></i> Каталог</button>\n          </div>\n        </yield>\n        <yield to="body">\n          <datatable-cell name="" style="width: 100px;"><i class="fa fa-fw {row.isMain ? &quot;fa-check-square-o&quot; : &quot;fa-square-o&quot;}" onclick="{handlers.isMainClick}"></i>&nbsp;<a onclick="{handlers.showImage}" href="{row.imageUrl}"><img riot-src="{row.imageUrlPreview}" height="64px" width="64px"></a></datatable-cell>\n          <datatable-cell name="">\n            <p class="form-control-static">{row.imageFile}</p>\n            <label class="form-control-title">Title\n              <input class="form-control" value="{row.imageTitle}" onchange="{handlers.imageTitleChange}">\n            </label>\n            <label class="form-control-title">Alt\n              <input class="form-control" value="{row.imageAlt}" onchange="{handlers.imageAltChange}">\n            </label>\n          </datatable-cell>\n        </yield>\n      </catalog-static>\n    </div>\n  </div>\n', '', '', function(opts) {
'use strict';

var self = this;
self.mixin('permissions');
self.newIndex = -1;
self.oldIndex = -1;

Object.defineProperty(self.root, 'value', {
    get: function get() {
        return self.value;
    },
    set: function set(value) {
        self.value = value || [];
        self.update();
    }
});

self.add = function () {};

self.cols = [{ name: '', value: 'Картинка' }, { name: '', value: 'Наименование' }];

self.handlers = {
    imageAltChange: function imageAltChange(e) {
        e.item.row.imageAlt = e.target.value;
    },
    imageTitleChange: function imageTitleChange(e) {
        e.item.row.imageTitle = e.target.value;
    },
    isMainClick: function isMainClick(e) {
        self.tags['catalog-static'].items.forEach(function (item, sort) {
            item.isMain = false;
        });
        e.item.row.isMain = true;
        self.update();
    },
    showImage: function showImage(e) {
        window.open(e.item.row.imageUrl, "", "resizable=yes,width=800,height=600");
    }
};

self.catalog = function (e) {
    modals.create('images-gallery-modal', {
        type: 'modal-primary',
        section: opts.section,
        submit: function submit() {
            self.value = self.value || [];
            this.tags.gallery.items.forEach(function (item) {
                if (item.__selected__) self.value.push({
                    imageFile: item.name,
                    imageAlt: self.parent.item.name,
                    imageUrlPreview: app.getImagePreviewURL(item.name, opts.section, opts.size),
                    imageUrl: app.getImageUrl(item.name, opts.section)
                });
            });

            var event = document.createEvent('Event');
            event.initEvent('change', true, true);
            self.root.dispatchEvent(event);

            self.update();
            this.modalHide();
        }
    });
};

self.upload = function (e) {
    var formData = new FormData();
    var items = [];

    for (var i = 0; i < e.target.files.length; i++) {
        formData.append('file' + i, e.target.files[i], e.target.files[i].name);
        items.push(e.target.files[i].name);
    }

    API.upload({
        section: opts.section,
        count: e.target.files.length,
        data: formData,
        success: function success(response) {
            items = response.items;
            self.value = self.value || [];
            items.forEach(function (item) {
                self.value.push({
                    imageFile: item.name,
                    imageAlt: '',
                    imageUrlPreview: item.imageUrlPreview,
                    imageUrl: item.imageUrl
                });
            });

            var event = document.createEvent('Event');
            event.initEvent('change', true, true);
            self.root.dispatchEvent(event);

            self.update();
        }
    });
};

self.on('updated', function () {
    self.tags['catalog-static'].tags.datatable.on('reorder-end', function (newIndex, oldIndex) {
        if (newIndex === self.newIndex && oldIndex === self.oldIndex) {
            return false;
        }

        self.newIndex = newIndex;
        self.oldIndex = oldIndex;

        //let {current, limit} = self.tags.childs.pages
        //let offset = current > 0 ? (current - 1) * limit : 0
        self.tags['catalog-static'].value.splice(newIndex, 0, self.tags['catalog-static'].value.splice(oldIndex, 1)[0]);
        //self.tags['catalog-static'].value.splice(offset + newIndex, 0, self.tags['catalog-static'].value.splice(offset + oldIndex, 1)[0])
        var temp = self.tags['catalog-static'].value;
        self.rows = [];
        self.update();
        self.tags['catalog-static'].value = temp;

        self.tags['catalog-static'].items.forEach(function (item, sort) {
            item.sortIndex = sort;
        });
        //self.update()
    });
});

self.on('update', function () {
    if ('name' in opts && opts.name !== '') self.root.name = opts.name;

    if ('value' in opts) self.value = opts.value || [];
});
});


// WEBPACK FOOTER //
// ./pages/products/products/product-edit-images.tag